/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
/* eslint-disable max-classes-per-file */

export class ApplicationAttachment {
    
   

    fileName?: string;

    fileType?: string;


    fileContent?: any;

    fileSize!:string;

   
}

export enum Countries{
    Egypt = 1
}




